import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import SortableTable from 'shared/ui/table/SortablePaginatedTable';
import { PageListHead, PageListTitle } from 'shared/styles/components/PageList';
import { ERROR_MESSAGES, PAGE_INFO } from 'shared/constants/messages';
import threeDots from '../../../assets/svg/three-dots.svg';
import { DropdownMenu, DropboxToggle } from '../../../shared/styles/components/Dropdown';
import 'bootstrap/dist/css/bootstrap.css';
import { getUnformattedDuid } from 'shared/utilities/general';
// import DeviceInfo from './deviceInfo';
import { decorateOrder, getOrders } from 'core/api/orders';
import { decorateDevice } from 'core/api/deviceOperations';
import { PAGINATION_DEFAULT_OPTION } from 'shared/constants/pagination';
import { clearAndRestoreAddons } from 'core/redux/addOn.js/action';
import { useSelector, useDispatch } from 'react-redux';
import { setExternalSearch } from '../../../core/redux/subscriptions/actions';
import spinner from '../../../assets/images/loader-sp.gif';
import { TruncatedText } from 'shared/styles/components/TruncatedText';
import OrderDeviceInfo from './orderDeviceInfo';
import IconSvgComponent from 'shared/ui/icons/IconSvgComponent';
import { BackButton } from 'shared/styles/components/BackButton';

const orderList = ({
  isError,
  hideEnvDropdown,
  setInitialLoads,
  stackSelection,
  selectedStack,
  setStackAccount,
  selectedAccount,
  showNotification,
  setSearchTextGlobal,
}) => {
  const [resetPageNo, setResetPageNo] = useState(false);
  const [orders, setOrders] = useState([]);
  const [isFetchingOrders, setIsFetchingOrders] = useState(false);
  const { deviceId, awsAccount } = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const [currentRowIndex, setCurrentRowIndex] = useState(null);
  const [showDevice, setShowDevice] = useState(false);
  const [showAddon, setShowAddon] = useState(false);

  const dispatch = useDispatch();

  // API call for fetching device data.
  const fetchOrders = async (
    pageSize = PAGINATION_DEFAULT_OPTION.value,
    lastEvaluatedKey1,
    awsAccount,
    stack,
    searchId = null
  ) => {
    try {
      setIsFetchingOrders(true);
      const { response } = await getOrders(pageSize, lastEvaluatedKey1, awsAccount, stack, searchId);
      if (response.subscriptionOrders) {
        let temp = [];
        response.subscriptionOrders.map((orders) =>
          temp.push(
            decorateOrder({
              orderFromAPI: orders,
            })
          )
        );
        setOrders(temp);
        setIsFetchingOrders(false);
      } else {
        setIsFetchingOrders(false);
      }
    } catch (e) {
      setIsFetchingOrders(false);
      console.log(e);
      // setInitialLoads(true);
      showNotification(e);
    }
  };

  // Env dropdown change handler
  const optionChangeHandler = (e) => {
    setStackAccount(e);
    stackSelection(null);
    // dispatch(setOrg(null));
    setOrders([]);
    setSearchTextGlobal('');
  };

  const stackChangeHandler = (e) => {
    if (e.value !== selectedStack?.value) {
      setOrders([]);
      stackSelection(e);
      // refreshOrgList(selectedAccount, e);
      setSearchTextGlobal('');
    }
  };

  // function for making API call and fetching record based on organization and device ID
  const onClickSearchIconOnSubscription = async (searchText) => {
    // console.log(searchText, 'searchText');
    setSearchTextGlobal(searchText.search_key);

    // to prevent multiple blank search when loading in progress
    const searchId = searchText.search_key;
    console.log(searchId, selectedAccount?.value?.toLowerCase(), selectedStack?.value);
    if (
      searchId === '' ||
      (selectedAccount && !selectedAccount?.value?.toLowerCase()) ||
      (selectedStack && !selectedStack?.value)
    ) {
      return;
    }
    setOrders([]);
    fetchOrders(undefined, undefined, selectedAccount.value.toLowerCase(), selectedStack.value, searchId);
  };

  // Custom Toggle indicator
  const GridActionToggle = React.forwardRef(({ onClick }, ref) => (
    <DropboxToggle
      href=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <img src={threeDots} />
    </DropboxToggle>
  ));

  GridActionToggle.displayName = 'CustomToggle';

  // Custom Dropdown List
  const GridActionMenu = React.forwardRef(({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
    const [value] = useState('');
    return (
      <DropdownMenu ref={ref} style={style} className={className} aria-labelledby={labeledBy} rightAlign>
        {React.Children.toArray(children).filter(
          (child) => !value || child.props.children.toLowerCase().startsWith(value)
        )}
      </DropdownMenu>
    );
  });

  GridActionMenu.displayName = 'CustomMenu';

  // custom message for Device page
  const showCustomizeMessage = () => {
    return ERROR_MESSAGES.EMPTY_TEXT;
  };

  let columns = [
    {
      title: 'Organization ID',
      dataIndex: 'orgId',
      searchIndex: 'searchableOrgId',
      key: 'orgId',
      searchable: true,
      width: '15%',
      render(value, order) {
        return (
          <span title={'Organization ID: ' + (order?.organization_id ? order?.organization_id : '-')}>
            <TruncatedText Vname>{order.organization_id}</TruncatedText>
          </span>
        );
      },
    },
    {
      title: 'Subscription ID',
      dataIndex: 'name',
      searchIndex: 'searchableSubscriptionId',
      key: 'name',
      searchable: true,
      width: '15%',
      render(value, order) {
        return (
          <span title={'Subscription ID: ' + (order?.searchableSubscriptionId ? order?.searchableSubscriptionId : '-')}>
            <TruncatedText Vname>{order?.searchableSubscriptionId}</TruncatedText>
          </span>
        );
      },
    },
    {
      title: 'Vehicles',
      dataIndex: 'name',
      searchIndex: 'searchableVehicles',
      key: 'name',
      searchable: true,
      width: '10%',
      render(value, order, rowIndex) {
        return (
          <IconSvgComponent
            title={'Vehicles Information'}
            svgFileName={'vehiclesDetails'}
            alt="Back"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setShowDevice(true);
              setCurrentRowIndex(rowIndex);
              setIsOpen(true);
            }}
          />
        );
      },
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      searchIndex: 'searchableStartDate',
      key: 'status',
      searchable: true,
      width: '9%',
      render(value, order) {
        return (
          <span title={'Start Date: ' + (order?.searchableStartDate ? order?.searchableStartDate : '-')}>
            <TruncatedText Vname>{order.searchableStartDate}</TruncatedText>
          </span>
        );
      },
    },
    {
      title: 'EndDate',
      dataIndex: 'endDate',
      searchIndex: 'searchableEndDate',
      key: 'status',
      searchable: true,
      width: '9%',
      render(value, order) {
        return (
          <span title={'End Date: ' + (order?.searchableEndDate ? order?.searchableEndDate : '-')}>
            <TruncatedText Vname>{order.searchableEndDate}</TruncatedText>
          </span>
        );
      },
    },
    {
      title: 'Grace period end date',
      dataIndex: 'status',
      searchIndex: 'searchableGracePeriodenddate',
      key: 'status',
      searchable: true,
      width: '9%',
      render(value, order) {
        return (
          <span
            title={
              'Grace Period End Date: ' +
              (order?.searchableGracePeriodEndDate ? order?.searchableGracePeriodEndDate : '-')
            }
          >
            <TruncatedText Vname>{order?.searchableGracePeriodEndDate}</TruncatedText>
          </span>
        );
      },
    },
    {
      title: 'Purchase date',
      dataIndex: 'status',
      searchIndex: 'searchablePurchase date',
      key: 'status',
      searchable: true,
      width: '9%',
      render(value, order) {
        return (
          <span title={'Purchase Date: ' + (order?.searchablePurchase ? order?.searchablePurchase : '-')}>
            <TruncatedText Vname>{order.searchablePurchase}</TruncatedText>
          </span>
        );
      },
    },
    {
      title: 'Record type',
      dataIndex: 'recordType',
      searchIndex: 'searchableRecordtype',
      key: 'status',
      searchable: true,
      width: '9%',
      render(value, order) {
        return (
          <span title={'Record Type: ' + (order?.searchableRecordType ? order?.searchableRecordType : '-')}>
            <TruncatedText Vname>{order.searchableRecordType}</TruncatedText>
          </span>
        );
      },
    },
    {
      title: 'Seats Basic Total',
      dataIndex: 'seatsBasicTotal',
      searchIndex: 'searchableSeatsBasicTotal',
      key: 'status',
      searchable: true,
      width: '9%',
      render(value, order) {
        return (
          <span
            title={'Seats Basic Total: ' + (order?.searchableSeatsBasicTotal ? order?.searchableSeatsBasicTotal : '-')}
          >
            <TruncatedText Vname>{order?.searchableSeatsBasicTotal}</TruncatedText>
          </span>
        );
      },
    },
    {
      title: 'seats premium total',
      dataIndex: 'seatsPremiumTotal',
      searchIndex: 'searchableSeatsPremiumTotal',
      key: 'status',
      searchable: true,
      width: '9%',
      render(value, order) {
        return (
          <span
            title={
              'Seats Premium Total: ' + (order?.searchableSeatsPremiumTotal ? order?.searchableSeatsPremiumTotal : '-')
            }
          >
            <TruncatedText Vname>{order?.searchableSeatsPremiumTotal}</TruncatedText>
          </span>
        );
      },
    },
    {
      title: 'seats total',
      dataIndex: 'seatsTotal',
      searchIndex: 'searchableSeatsTotal',
      key: 'status',
      searchable: true,
      width: '9%',
      render(value, order) {
        return (
          <span title={'Seats Total: ' + (order?.searchableSeatsTotal ? order?.searchableSeatsTotal : '-')}>
            <TruncatedText Vname>{order.searchableSeatsTotal}</TruncatedText>
          </span>
        );
      },
    },
    {
      title: 'Addons',
      dataIndex: 'addons',
      searchIndex: 'searchableAddons',
      key: 'name',
      searchable: true,
      width: '20%',
      render(value, order, rowIndex) {
        return (
          <IconSvgComponent
            title={'Addons Information'}
            svgFileName={'addons'}
            alt="Back"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setShowAddon(true);
              setCurrentRowIndex(rowIndex);
              setIsOpen(true);
            }}
          />
        );
      },
    },
    {
      title: 'Created',
      dataIndex: 'created',
      searchIndex: 'searchableCreated',
      key: 'status',
      searchable: true,
      width: '9%',
      render(value, order) {
        return (
          <span title={'Created: ' + (order?.searchableCreated ? order?.searchableCreated : '-')}>
            <TruncatedText Vname>{order.searchableCreated}</TruncatedText>
          </span>
        );
      },
    },
    {
      title: 'Last updated',
      dataIndex: 'lastUpdated',
      searchIndex: 'searchableLastUpdated',
      key: 'status',
      searchable: true,
      width: '9%',
      render(value, order) {
        return (
          <span title={'Last Updated: ' + (order?.searchableLastUpdated ? order?.searchableLastUpdated : '-')}>
            <TruncatedText Vname>{order.searchableLastUpdated}</TruncatedText>
          </span>
        );
      },
    },
  ];

  return (
    <>
      <div>
        <>
          {isOpen ? (
            <>
              <PageListHead subscription>
                <BackButton className="backbtn">
                  <IconSvgComponent
                    svgFileName={'corner-up-left'}
                    alt="Back"
                    onClick={() => {
                      setIsOpen(false);
                      setShowAddon(false);
                      setShowDevice(false);
                    }}
                  />
                </BackButton>
                <PageListTitle subscription>
                  {`Organization ID: ${orders[currentRowIndex]?.organization_id}`}
                </PageListTitle>
              </PageListHead>
              <OrderDeviceInfo
                close={() => {
                  setIsOpen(false);
                  setShowAddon(false);
                  setShowDevice(false);
                }}
                addons={showAddon ? orders[currentRowIndex]?.addons : []}
                devices={showDevice ? orders[currentRowIndex]?.devices : []}
                organizationId={orders[currentRowIndex]?.organization_id}
                showDevice={showDevice}
                showAddon={showAddon}
              />
            </>
          ) : (
            <span className={deviceId && awsAccount ? 'hideDeviceList' : ''}>
              <PageListHead>
                <PageListTitle>Orders</PageListTitle>
              </PageListHead>
              <div>
                Total of {orders.length} Orders{' '}
                {isFetchingOrders ? <img src={spinner} style={{ width: '16px', height: '16px' }} /> : null}
              </div>
              <SortableTable
                className="table-simple"
                columns={columns}
                tableData={orders}
                scroll={{ x: false, y: false }}
                rowKey={(record) => record.orgId}
                refresh={resetPageNo}
                emptyText={() => showCustomizeMessage()}
                selectedAccount={selectedAccount}
                selectedStack={selectedStack}
                hideEnvDropdown={hideEnvDropdown}
                optionChangeHandler={optionChangeHandler}
                stackChangeHandler={stackChangeHandler}
                setSearchTextGlobalSubs={setSearchTextGlobal}
                onClickSearchIconOnSubscription={(ob) => onClickSearchIconOnSubscription(ob)}
              />
            </span>
          )}
        </>
      </div>
    </>
  );
};

export default connect(
  (state) => ({
    isError: state.deviceOperations?.isError,
    envList: state.user.envList,
    deviceId: state?.deviceOperations?.deviceId,
    addons: state.addons.addons,
  }),
  (dispatch) => ({
    // clearAndRestoreOrders: (selectedAccount, selectedStack) =>
    //   dispatch(clearAndRestoreOrders(selectedAccount, selectedStack)),
    // device_Reset: (deviceDetails) => dispatch(device_Reset(deviceDetails)),
    // clearAndRestoreAddons: (selectedAccount, selectedStack) =>
    //   dispatch(clearAndRestoreAddons(selectedAccount, selectedStack)),
  })
)(orderList);
